
interface HeroProps {
  scrollToContact: () => void;
}

export default function Hero({ scrollToContact }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/cdc991996852787e11dfbee0933087d9.jpg"
          alt="VPN Network Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div className="inline-block mb-6 px-6 py-2 border border-white/30 rounded-full backdrop-blur-sm">
          <span className="text-white text-sm tracking-wider">ENTERPRISE VPN SOLUTION</span>
        </div>
        
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-thin text-white mb-8 tracking-wide">
          SECURE YOUR<br />DIGITAL PRESENCE
        </h1>
        
        <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto font-light">
          Experience unrestricted internet access with enterprise-level security
        </p>
        
        <button 
          onClick={scrollToContact}
          className="group inline-flex items-center gap-4 bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
        >
          <span className="text-lg font-medium">Get Started Now</span>
          <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
        </button>
      </div>
    </section>
  );
}
